export default class Mask {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return '9999 aa';
    }

    birthdate() {
        return '39-19-2999';
    }
}
